import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FileCompareComponent } from './file-compare/file-compare.component';
import { RoleGuard } from '../../guards/role.guard';
import { Role } from '../../models/role.model';
import { PrerequisitesGuard } from '../../guards/prerequisites.guard';
import { BrowseComponent } from './browse/browse.component';
import { AppContainerComponent } from "../layout/app-container/app-container.component";

const reviewRoutes: Routes = [
	{ path: 'browse', redirectTo: 'review/browse', pathMatch: 'full' },
	{ path: 'search', redirectTo: 'review/browse', pathMatch: 'full' },
	{ path: 'doc-viewer', redirectTo: 'review/doc-viewer', pathMatch: 'full' },
	{
		path: 'review',
		component: AppContainerComponent,
		children: [
			{ path: 'compare', component: FileCompareComponent, canActivate: [PrerequisitesGuard, RoleGuard], data: { roles: [Role.StandardFeatureSet] } },
			{ path: 'browse', component: BrowseComponent, canActivate: [PrerequisitesGuard, RoleGuard], data: { roles: [Role.StandardFeatureSet, Role.LimitedFeatureSet] } },
			{ path: 'search', redirectTo: 'browse', pathMatch: 'full' },
		]
	}
];

@NgModule({
	imports: [
		RouterModule.forChild(reviewRoutes)
	],
	exports: [
		RouterModule
	]
})
export class ReviewRoutingModule { }
